module.exports = window['adobe_dc_sdk']['dc-extras'];